<template>
  <div class="container">
    <div class="title">{{ $t('safe').SecuritySettings }}</div>
    <div class="info">
      <div class="lable">{{ $t('safe').Accountsecurity }}</div>
      <div class="content">
        <!-- 手机 -->
        <div class="item">
          <div class="left">
            <span>{{ $t('safe').phone }}</span>
          </div>
          <div v-if="userInfo.phonenumber">
            <span>{{ userInfo.phonenumber | truncateString }}</span>
          </div>
          <div v-else @click="$router.push({ name: 'BindPhone' })">
            <span>{{ $t('safe').Notyetbound }}</span>
            <van-icon name="arrow" size="15" color="var(--ntext_color)" />
          </div>
        </div>
        <!-- 邮箱 -->
        <div class="item">
          <div class="left">
            <span>{{ $t('safe').mailbox }}</span>
          </div>
          <div v-if="userInfo.email">
            <span>{{ userInfo.email | truncateString }}</span>
          </div>
          <div v-else @click="$router.push({ name: 'BindEmail' })">
            <span>{{ $t('safe').Notyetbound }}</span>
            <van-icon name="arrow" size="15" color="var(--ntext_color)" />
          </div>
        </div>
        <!-- 登录密码 -->
        <div class="item" @click="$router.push({ name: 'UpLoginPwd' })">
          <div class="left">
            <span>{{ $t('safe').Loginpassword }}</span>
          </div>
          <div>
            <van-icon name="arrow" size="15" color="var(--ntext_color)" />
          </div>
        </div>
        <!-- 资金密码 -->
        <div class="item" @click="$router.push({ name: 'UpPayPwd' })">
          <div class="left">
            <span>{{ $t('safe').Fundcode }}</span>
          </div>
          <div>
            <span>{{ $t('safe').Settings }}</span>
            <van-icon name="arrow" size="15" color="var(--ntext_color)" />
          </div>
        </div>
        <!-- 提币地址管理 -->
        <div class="item" @click="$router.push({ name: 'WalletAddress' })">
          <div class="left">
            <span>{{ $t('safe').Withdrawaladdressmanagement }}</span>
          </div>
          <div>
            <van-icon name="arrow" size="15" color="var(--ntext_color)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      userInfo: {},
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 780px;

    .lable {
      padding: 50px 0 5px 0;
      font-size: 18px;
      color: var(--ntext_color);
    }

    .content {
      .item {
        padding: 30px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--info_color);

        .left {
          display: flex;
          align-items: center;

          span {
            font-size: 18px;
            color: var(--text_color);
          }
        }

        span {
          font-size: 15px;
          color: var(--ntext_color);
          margin-right: 10px;
        }
      }
      .item:hover{
        background: var(--info_color);
      }
    }
  }
}
</style>
